import { Box, Center, Flex, Spacer, Text } from '@chakra-ui/react';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type { Portfolio } from '../../_openapi/portfolio-optimizer';
import { PageContent } from '../../widgets/PageContent';
import { PageHeader } from '../../widgets/PageHeader';
import { PortfolioSelector } from '../../widgets/PortfolioSelector';
import { PortfolioTabs } from '../PortfolioTabs';

export const PortfolioWatcher: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const selectedPId = searchParams.get('pId') ?? undefined;

    const handlePortfolioSelect = (portfolio: Portfolio) => {
        if (portfolio?.base?.pId) {
            navigate(`/portfolio-watcher?pId=${portfolio.base.pId}`);
        }
    };

    return (
        <>
            <PageHeader title="Account Watcher">
                <Flex alignItems="center" width="100%" flex={1}>
                    <Spacer />
                    <Box width="800px">
                        <PortfolioSelector
                            onSelect={handlePortfolioSelect}
                            placeholder="Select a portfolio"
                            resetOnSelect
                        />
                    </Box>
                </Flex>
            </PageHeader>
            <PageContent>
                {!selectedPId ? (
                    <Center width="100%" height="50vh">
                        <Text>Please select a portfolio!</Text>
                    </Center>
                ) : (
                    <PortfolioTabs pId={selectedPId} />
                )}
            </PageContent>
        </>
    );
};
